(function () {
  'use strict';

  const ACCORDION_SELECTOR = '.mobile-facets__wrapper .mobile-facets__details';
  const SUBMENU_SELECTOR = ':scope > .mobile-facets__submenu';
  const OPEN_CLASS = 'kg-accordion-open';
  const DURATION = 420;

  function getSubmenu(details) {
    return details.querySelector(SUBMENU_SELECTOR);
  }

  function cancelPending(details) {
    if (details._kgAccordionTimeout) {
      clearTimeout(details._kgAccordionTimeout);
      details._kgAccordionTimeout = null;
    }
  }

  function openAccordion(details) {
    const submenu = getSubmenu(details);
    if (!submenu) return;
    cancelPending(details);

    details.classList.add(OPEN_CLASS);
    details.setAttribute('open', '');

    submenu.style.transition = 'none';
    submenu.style.height = '0px';
    submenu.style.overflow = 'hidden';
    // eslint-disable-next-line no-unused-expressions
    void submenu.offsetHeight;
    submenu.style.transition = '';
    const target = submenu.scrollHeight;
    submenu.style.height = target + 'px';

    details._kgAccordionTimeout = setTimeout(() => {
      if (details.classList.contains(OPEN_CLASS)) {
        submenu.style.height = '';
        submenu.style.overflow = '';
      }
      details._kgAccordionTimeout = null;
    }, DURATION);
  }

  function closeAccordion(details) {
    const submenu = getSubmenu(details);
    if (!submenu) return;
    cancelPending(details);

    const current = submenu.scrollHeight;
    submenu.style.transition = 'none';
    submenu.style.height = current + 'px';
    submenu.style.overflow = 'hidden';
    // eslint-disable-next-line no-unused-expressions
    void submenu.offsetHeight;

    details.classList.remove(OPEN_CLASS);
    submenu.style.transition = '';
    submenu.style.height = '0px';

    details._kgAccordionTimeout = setTimeout(() => {
      details.removeAttribute('open');
      submenu.style.height = '';
      submenu.style.overflow = '';
      submenu.style.transition = '';
      details._kgAccordionTimeout = null;
    }, DURATION);
  }

  function bindAccordion(details) {
    if (details.dataset.kgAccordionBound === 'true') return;
    details.dataset.kgAccordionBound = 'true';

    const summary = details.querySelector(':scope > summary');
    if (!summary) return;

    if (details.hasAttribute('open')) {
      details.classList.add(OPEN_CLASS);
    }

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      if (details.classList.contains(OPEN_CLASS)) {
        closeAccordion(details);
      } else {
        openAccordion(details);
      }
    });
  }

  function initAccordions(root) {
    const scope = root || document;
    scope.querySelectorAll(ACCORDION_SELECTOR).forEach(bindAccordion);
  }

  let suppressApplyCountUpdate = false;

  function syncApplyCount() {
    if (suppressApplyCountUpdate) return;
    const sourceEl = document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop');
    if (!sourceEl) return;
    const text = sourceEl.textContent.trim();
    const matches = text.match(/\d[\d.,\s]*/g);
    if (!matches || !matches.length) return;
    const number = matches[matches.length - 1].trim();
    const targets = document.querySelectorAll('[data-product-count]');
    if (!targets.length) return;

    suppressApplyCountUpdate = true;
    try {
      targets.forEach((el) => {
        if (el.textContent !== number) {
          el.textContent = number;
        }
      });
    } finally {
      // Release the flag on the next microtask so any mutations triggered
      // synchronously by our textContent updates have already been queued
      // and can be ignored by our observers.
      Promise.resolve().then(() => {
        suppressApplyCountUpdate = false;
      });
    }
  }

  function watchProductCount() {
    const targets = ['ProductCount', 'ProductCountDesktop']
      .map((id) => document.getElementById(id))
      .filter(Boolean);
    targets.forEach((target) => {
      const observer = new MutationObserver(() => {
        if (suppressApplyCountUpdate) return;
        syncApplyCount();
      });
      observer.observe(target, { childList: true, characterData: true, subtree: true });
    });
    syncApplyCount();
  }

  function observeDrawerRerender() {
    const drawer = document.querySelector('.facets-container-drawer');
    if (!drawer) return;
    let scheduled = false;
    const observer = new MutationObserver((mutations) => {
      if (suppressApplyCountUpdate) return;
      // Skip pure text/character mutations coming from our own count updates
      const meaningful = mutations.some((m) => {
        if (m.type !== 'childList') return false;
        // Ignore changes that only swap text inside the apply count node
        if (m.target && m.target.closest && m.target.closest('[data-product-count]')) return false;
        return true;
      });
      if (!meaningful) return;
      if (scheduled) return;
      scheduled = true;
      requestAnimationFrame(() => {
        scheduled = false;
        initAccordions(drawer);
        syncApplyCount();
      });
    });
    observer.observe(drawer, { childList: true, subtree: true });
  }

  function init() {
    initAccordions();
    watchProductCount();
    observeDrawerRerender();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
